/*
 * @Author: chenyan
 * @Date: 2017-12-20 14:45:10
 * @Description: website网站管理
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2018-08-28 14:30:43
 */

import api from '@/api/index'

const state = {
  withdrawStoreListInfo: null, // 打款网站信息
  withdrawListInfo: null, // 获取打款记录信息
  selfWithdrawListInfo: null, //获取提现记录
  withdrawRes:null,//提现响应
}

const mutations = {
  getWithdrawStoreList(state, data) {
      state.withdrawStoreListInfo = _.cloneDeep(data)
  },
  loadWithdrawList(state, data) {
      state.withdrawListInfo = _.cloneDeep(data)
  },
  loadSelfWithdrawList(state, data) {
    state.selfWithdrawListInfo = _.cloneDeep(data)
  },
  doWithdraw(state, data) {
    state.withdrawRes = _.cloneDeep(data)
  }
}

const actions = {
    // 获取打款网站
    getWithdrawStoreList: async ({ commit, state }, param) => {
      const data = await api.getWithdrawStoreList()
      if (data) {
      commit('getWithdrawStoreList', data)
      }
    },
    // 获取打款记录列表
    loadWithdrawList: async ({ commit, state }, param) => {
      const data = await api.loadWithdrawList(param)
      if (data) {
      commit('loadWithdrawList', data)
      }
    },

    // 获取提现记录列表
    loadSelfWithdrawList: async ({ commit, state }, param) => {
      const data = await api.loadSelfWithdrawList(param)
      if (data) {
      commit('loadSelfWithdrawList', data)
      }
    },

    doWithdraw: async ({ commit, state }, param) => {
      const data = await api.doWithdraw(param)
      if (data) {
        commit('doWithdraw', data)
      }
    },

  }
  const getters = {
    withdrawStoreListInfo: state => state.withdrawStoreListInfo,
    withdrawListInfo: state => state.withdrawListInfo,
    selfWithdrawListInfo: state => state.selfWithdrawListInfo,
    withdrawRes: state => state.withdrawRes,
  }

  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  }
